<h1 class="player-name">{{ playerName$ | async }}</h1>
<ng-template #tracks let-item style="background: rgb(255 255 255 / 48%);">
  <mwo-track [item]="item" [mode]="'playlist'"></mwo-track>
</ng-template>
<div class="playlist-container">
  <mwo-smart-grid [hasSettings]="false" [itemTpl]="tracks" [list]="wishlistTracks$" [mode]="'vertical'">
    <h3 previousPage>{{ "library.title" | translate }}</h3>
    <div class="playlist-header-container" header>
      <div class="playlist-header">
        <mwo-smart-cover [coverTitle]="'WISHLIST'" [item]="wishlist" class="playlist-cover"></mwo-smart-cover>
        <h2 class="playlist-title"> WISHLIST</h2>

        <div class="playlist-actions">
          <button (click)="play('WISHLIST')" class="action">
            <mwo-action-button [alt]="'play'" [icon]="'/assets/icons/play.svg'"
                               [translationKey]="'playlist.play'"></mwo-action-button>
          </button>
          <button class="action">
            <mwo-action-button [alt]="'shuffle'" [icon]="'/assets/icons/shuffle.svg'"
                               [translationKey]="'playlist.shuffle'"></mwo-action-button>
          </button>
        </div>
      </div>
      <div class="playlist-tracklist-header tracklist-header">
        <p class="playlist-tracklist-header-title">{{ 'playlist.title' | translate }}</p>
        <p class="playlist-tracklist-header-artist">{{ 'playlist.artist' | translate }}</p>
        <p class="playlist-tracklist-header-duration">{{ 'playlist.duration' | translate }}</p>
      </div>
    </div>
  </mwo-smart-grid>
</div>
